/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import icons from '@/shell/icons/icons';
import {UserVuetifyPreset} from 'vuetify';
import {colors} from '@/shell/plugins/colors';


export const vuetifyPresets: Partial<UserVuetifyPreset> = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: colors
    }
  },
  icons: {
    iconfont: 'mdiSvg',
    values: icons
  }
};
